export default {
  metaTitle: {
    id: 'merchant_options_meta_title',
    defaultMessage: 'Options',
  },
  title: {
    id: 'merchant_options_title',
    defaultMessage: 'Options',
  },
  navigation: {
    id: 'merchant_options_title',
    defaultMessage: 'Options navigation',
  },
  tabMarkets: {
    id: 'merchant_options_markets',
    defaultMessage: 'Markets',
  },
  tabAddresses: {
    id: 'merchant_options_addresses',
    defaultMessage: 'Addresses',
  },
  tabShipping: {
    id: 'merchant_options_shipping',
    defaultMessage: 'Shipping',
  },
  tabPayment: {
    id: 'merchant_options_payment',
    defaultMessage: 'Payment',
  },
  tabComments: {
    id: 'merchant_options_comments',
    defaultMessage: 'Comments',
  },
  tabPricing: {
    id: 'merchant_options_pricing',
    defaultMessage: 'Pricing',
  },
  tabBackPricer: {
    id: 'merchant_options_backpricer',
    defaultMessage: 'BackPricer',
  },
  tabIntegrations: {
    id: 'merchant_options_integrations',
    defaultMessage: 'API & Integrators',
  },
  tabBatchListingCreation: {
    id: 'merchant_options_batch_listing_creation',
    defaultMessage: 'Batch Listing Creation',
  },
}
